import { supabase } from './supabase.js';

const COLECCION_SELECT =
  'id,user_id,title,artist,release_year,format,condition_text,notes,created_at,is_joya,open_to_offers,' +
  'genre,label_name,country,condition_code,description,cover_url,photo_url_2,photo_url_3,' +
  'es_conjunto,conjunto_titulo,conjunto_num_discos,conjunto_descripcion,' +
  'es_edicion_especial,edicion_nombre,edicion_catalogo,edicion_contenido,edicion_numerada,edicion_numero_ejemplar';

function normalizeColeccionRow(row) {
  if (!row) return row;
  return {
    ...row,
    is_joya: !!row.is_joya,
    open_to_offers: !!row.open_to_offers,
    es_conjunto: !!row.es_conjunto,
    es_edicion_especial: !!row.es_edicion_especial,
    edicion_numerada: !!row.edicion_numerada,
  };
}

/**
 * @param {string} userId
 */
export async function listProfileColeccion(userId) {
  if (!userId) return [];
  const { data, error } = await supabase
    .from('profile_coleccion_items')
    .select(COLECCION_SELECT)
    .eq('user_id', userId)
    .order('created_at', { ascending: false });
  if (error) throw error;
  return (data ?? []).map(normalizeColeccionRow);
}

/**
 * @param {string} userId
 * @param {object} row — campos alineados con el formulario tipo Publicar (ver migración 291400).
 */
export async function insertProfileColeccionItem(userId, row) {
  const insertRow = {
    user_id: userId,
    title: row.title.trim(),
    artist: row.artist.trim(),
    release_year: row.release_year != null && row.release_year !== '' ? Number(row.release_year) : null,
    format: row.format?.trim() || null,
    condition_text: row.condition_text?.trim() || null,
    notes: row.notes?.trim() || null,
    genre: row.genre?.trim() || null,
    label_name: row.label_name?.trim() || null,
    country: row.country?.trim() || null,
    condition_code: row.condition_code?.trim() || null,
    description: row.description?.trim() || null,
    cover_url: row.cover_url?.trim() || null,
    photo_url_2: row.photo_url_2?.trim() || null,
    photo_url_3: row.photo_url_3?.trim() || null,
    es_conjunto: !!row.es_conjunto,
    conjunto_titulo: row.conjunto_titulo?.trim() || null,
    conjunto_num_discos: row.conjunto_num_discos != null ? Number(row.conjunto_num_discos) : null,
    conjunto_descripcion: row.conjunto_descripcion?.trim() || null,
    es_edicion_especial: !!row.es_edicion_especial,
    edicion_nombre: row.edicion_nombre?.trim() || null,
    edicion_catalogo: row.edicion_catalogo?.trim() || null,
    edicion_contenido: row.edicion_contenido?.trim() || null,
    edicion_numerada: !!row.edicion_numerada,
    edicion_numero_ejemplar: row.edicion_numero_ejemplar?.trim() || null,
    is_joya: !!row.is_joya,
    open_to_offers: !!row.open_to_offers,
  };

  const { data, error } = await supabase.from('profile_coleccion_items').insert(insertRow).select(COLECCION_SELECT).single();
  if (error) throw error;
  return normalizeColeccionRow(data);
}

/**
 * @param {string} userId
 * @param {string} itemId
 * @param {{ is_joya?: boolean, open_to_offers?: boolean }} flags
 */
export async function updateProfileColeccionFlags(userId, itemId, flags) {
  const patch = {};
  if (typeof flags.is_joya === 'boolean') patch.is_joya = flags.is_joya;
  if (typeof flags.open_to_offers === 'boolean') patch.open_to_offers = flags.open_to_offers;
  if (Object.keys(patch).length === 0) return null;
  const { data, error } = await supabase
    .from('profile_coleccion_items')
    .update(patch)
    .eq('id', itemId)
    .eq('user_id', userId)
    .select(COLECCION_SELECT)
    .single();
  if (error) throw error;
  return normalizeColeccionRow(data);
}

export async function deleteProfileColeccionItem(userId, id) {
  const { error } = await supabase.from('profile_coleccion_items').delete().eq('id', id).eq('user_id', userId);
  if (error) throw error;
}
